import { render, staticRenderFns } from "./StatisticsStakingFilters.vue?vue&type=template&id=bb29f05e&scoped=true&"
import script from "./StatisticsStakingFilters.vue?vue&type=script&lang=js&"
export * from "./StatisticsStakingFilters.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsStakingFilters.vue?vue&type=style&index=0&id=bb29f05e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb29f05e",
  null
  
)

export default component.exports